import { DocumentNode, gql } from '@apollo/client'

export const GET_CRON: DocumentNode = gql`
    query GetCron {
        getCron {
            purpose
            minute
            hour
            day
            month
        }
    }
`

export const UPDATE_CRON: DocumentNode = gql`
    mutation UpdateCron($purpose: String!, $minute: String!, $hour: String!, $day: String!, $month: String!) {
        updateCron(purpose: $purpose, cron: { minute: $minute, hour: $hour, day: $day, month: $month })
    }
`
